var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "name",
            label: _vm.$t.__("common.labels.society_name")
          }
        },
        [
          _c("el-input", {
            staticClass: "form-fields-company-shorten--name",
            attrs: {
              name: "company",
              autocomplete: "on",
              "data-bot": _vm.getDatabot(
                "name",
                _vm.dataBotsContext,
                null,
                "company-popup"
              )
            },
            on: { input: _vm.searchCompanyByName },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.companiesList.length > 0
        ? _c(
            "div",
            { staticClass: "mt-0 mb-3" },
            [
              _c("el-alert", {
                staticClass: "mb-2 mt-2 alert alert-warning",
                attrs: {
                  closable: false,
                  title: _vm.$t.__(
                    "common.labels.company_already_exist_in_your_directory"
                  ),
                  type: "warning"
                }
              }),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.companiesList, function(company, index) {
                  return _c("form-fields-companies-list", {
                    key: index,
                    staticClass:
                      "form-fields-companies-list br b-1-gray-05 mb-2 gray-0-bkg px-3",
                    staticStyle: { height: "66px" },
                    attrs: { company: company, overview: true }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "type", label: _vm.$t.__("common.labels.type") } },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: { disabled: _vm.typeDisabled },
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            },
            _vm._l(_vm.typeList, function(option) {
              return _c("el-option", {
                key: option.label,
                attrs: {
                  "data-bot": _vm.getDatabot(
                    "type",
                    _vm.dataBotsContext,
                    null,
                    "company-popup"
                  ),
                  value: option,
                  label: _vm.tagsHuman[option].label
                }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }